import React from 'react';
import { FilterColumnProps } from '../types';

export function DateFilter({ value, onChange }: FilterColumnProps) {
  const currentValue = value.value_safe;

  const handleDateChange = (newValue: string) => {
    onChange({
      ...value,
      value_safe: newValue || null
    });
  };

  return (
    <div className="w-full">
      <input
        type="date"
        value={currentValue || ''}
        onChange={(e) => handleDateChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        style={{
          fontSize: '13px',
          fontFamily: 'Calibri,Arial,Helvetica,sans-serif'
        }}
      />
    </div>
  );
} 